const SimpleWishlist = (() => {

  const COOKIE_NAME = "wishlist";

  const getWishlist = () => {

    const match = document.cookie.match(
      new RegExp("(^|;) ?" + COOKIE_NAME + "=([^;]*)(;|$)")
    );

    return match ? JSON.parse(decodeURIComponent(match[2])) : [];

  };

  const saveWishlist = (list) => {

    const expiry = new Date();
    expiry.setDate(expiry.getDate() + 30);

    document.cookie =
      COOKIE_NAME +
      "=" +
      encodeURIComponent(JSON.stringify(list)) +
      "; expires=" +
      expiry.toUTCString() +
      "; path=/";

  };

  const updateHeader = (list) => {

    document.querySelectorAll(".wishlist_link").forEach((link) => {

      const bubble = link.querySelector(".wishlist-bubble");

      if (!bubble) return;

      if (list.length) {

        link.classList.add("active");
        bubble.classList.remove("hidden");
        bubble.textContent = list.length;

      } else {

        link.classList.remove("active");
        bubble.classList.add("hidden");
        bubble.textContent = "";

      }

    });

  };

  const toggleProduct = (btn) => {

    const varId = btn.dataset.var?.toString();
    if (!varId) return;

    let list = getWishlist();

    const index = list.findIndex(
      (item) => item.var.toString() === varId
    );

    if (index > -1) {

      list.splice(index, 1);
      btn.classList.remove("active");

    } else {

      const item = {

        id: btn.dataset.id,
        title: btn.dataset.title,
        handle: btn.dataset.handle,
        var: varId

      };

      list.push(item);
      btn.classList.add("active");

    }

    /* REMOVE DUPLICATES */

    const unique = [];
    const seen = new Set();

    list.forEach((item) => {

      if (!seen.has(item.var)) {

        seen.add(item.var);
        unique.push(item);

      }

    });

    saveWishlist(unique);
    updateHeader(unique);
    syncButtons();

    document.dispatchEvent(
      new CustomEvent("wishlist:updated", {
        detail: { wishlist: unique }
      })
    );

    if (typeof window.openWishlistDrawer === "function") {
      window.openWishlistDrawer();
    }

  };

  const syncButtons = () => {

    const list = getWishlist();

    document.querySelectorAll(".whishlist_icons").forEach((btn) => {

      const varId = btn.dataset.var?.toString();

      const exists = list.some(
        (item) => item.var.toString() === varId
      );

      btn.classList.toggle("active", exists);

    });

    updateHeader(list);

  };

  return {

    toggle: toggleProduct,
    syncButtons,
    getWishlist

  };

})();

document.addEventListener("DOMContentLoaded", () => {

  SimpleWishlist.syncButtons();

  document.addEventListener("click", (e) => {

    const btn = e.target.closest(".whishlist_icons");

    if (!btn) return;

    e.preventDefault();

    SimpleWishlist.toggle(btn);

  });

});